import { Brand } from '../types/BookingTypes';

// Import all brand logos
import oppoLogo from '../assets/oppo.jpg';
import vivoLogo from '../assets/Vivo.png';
import samsungLogo from '../assets/Samsung.png';
import redmiLogo from '../assets/mi.jpg';
import oneplusLogo from '../assets/oneplus.jpg';
import realmeLogo from '../assets/realme.jpg';
import motorolaLogo from '../assets/Motorala.jpg';
import honorLogo from '../assets/Honor.png';
import tecnoLogo from '../assets/techno.jpg';
import googleLogo from '../assets/google.jpg';
import nothingLogo from '../assets/Nothing.jpg';
import nokiaLogo from '../assets/nokia.jpg';
import asusLogo from '../assets/Asus.jpg';

const LOCAL_BRANDS = {
  "entity": [
    { 
      "id": 1, 
      "name": "IPHONE", 
      "status": 1,
      "logo": "https://www.apple.com/ac/structured-data/images/knowledge_graph_logo.png" // Apple logo not in assets
    },
    { 
      "id": 2, 
      "name": "OPPO", 
      "status": 1,
      "logo": oppoLogo
    },
    { 
      "id": 3, 
      "name": "VIVO", 
      "status": 1,
      "logo": vivoLogo
    },
    { 
      "id": 4, 
      "name": "SAMSUNG", 
      "status": 1,
      "logo": samsungLogo
    },
    { 
      "id": 5, 
      "name": "REDMI", 
      "status": 1,
      "logo": redmiLogo
    },
    { 
      "id": 6, 
      "name": "ONE PLUS", 
      "status": 1,
      "logo": oneplusLogo
    },
    { 
      "id": 7, 
      "name": "REALME", 
      "status": 1,
      "logo": realmeLogo
    },
    { 
      "id": 8, 
      "name": "Motorola", 
      "status": 1,
      "logo": motorolaLogo
    },
    { 
      "id": 9, 
      "name": "Honor", 
      "status": 1,
      "logo": honorLogo
    },
    { 
      "id": 10, 
      "name": "ASUS", 
      "status": 1,
      "logo": asusLogo
    },
    { 
      "id": 11, 
      "name": "Tecno", 
      "status": 1,
      "logo": tecnoLogo
    },
    { 
      "id": 12, 
      "name": "Google", 
      "status": 1,
      "logo": googleLogo
    },
    { 
      "id": 14, 
      "name": "Nothing", 
      "status": 1,
      "logo": nothingLogo
    },
    { 
      "id": 15, 
      "name": "Nokia", 
      "status": 1,
      "logo": nokiaLogo
    }
  ],
  "isSuccess": true,
  "errors": null,
  "exception": null,
  "message": null
};

export async function getBrands(): Promise<Brand[]> {
  return LOCAL_BRANDS.entity
    .filter(brand => brand.status === 1)
    .map(item => ({
      id: item.id,
      name: item.name,
      logo: item.logo,
    }));
} 